import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import * as styles from "./DreamNameExpansionTool.css";

export function DreamNameExpansionTool({
    action,
    disabled,
    icon,
    label,
}: {
    action: () => void;
    disabled: boolean;
    icon: EGlyphicon;
    label: string;
}) {
    return (
        <button
            type="button"
            className={styles.button}
            aria-label={label}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();

                if (!disabled) {
                    action();
                }
            }}
        >
            <Glyphicon icon={icon} />
        </button>
    );
}
